export const RATINGS_TABLE_DELETE_ROW = "RATINGS_TABLE_DELETE_ROW";
export const RATINGS_TABLE_UPDATE_ROW = "RATINGS_TABLE_UPDATE_ROW";